import { render } from "./FloatingTicketWidget.vue?vue&type=template&id=f38110dc"
import script from "./FloatingTicketWidget.vue?vue&type=script&lang=js"
export * from "./FloatingTicketWidget.vue?vue&type=script&lang=js"

import "./FloatingTicketWidget.vue?vue&type=style&index=0&id=f38110dc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__